export const RECO_DETAILS_ACTIONS = { 
    FETCH_DETAILS : 'FETCH_RECO_DETAILS',
    FETCH_DETAILS_SUCCESS : 'FETCH_RECO_DETAILS_SUCCESS',
    FETCH_DETAILS_FAILURE : 'FETCH_RECO_DETAILS_FAILURE',
    FETCHING_DETAILS : 'FETCHING_RECO_DETAILS',
    QUERY_CARD_LOADED : 'QUERY_CARD_LOADED'
}       

export const fetchingRecoDetails = () => {
    return{
        type : RECO_DETAILS_ACTIONS.FETCHING_DETAILS
    }
}

export function queryRecoCardLoaded(){
    return{
        type : RECO_DETAILS_ACTIONS.QUERY_CARD_LOADED
    }
}